import { useRef, useEffect } from "react";

export const useMouseOverOut = ({
  setIsOpen,
  isDropdownMenuOpen,
}: {
  setIsOpen: (isOpen: boolean) => void;
  isDropdownMenuOpen: boolean;
}) => {
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const handleMouseEnter = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    setIsOpen(true);
  };

  const handleMouseLeave = () => {
    if (isDropdownMenuOpen) return;
    timeoutRef.current = setTimeout(() => {
      setIsOpen(false);
    }, 200); // Small delay to prevent accidental closing
  };

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return { handleMouseEnter, handleMouseLeave };
};
